import Vue from 'vue'

export const authHeaders = ['access-token', 'client', 'uid'];

/**
 * Abstracted auth api requests
 */

export const authService = {


  // - **expected headers**:
  //   - **access-token**: _dKG2WG4AwcCZpPCHf-GyQ
  //   - **client**: hHcKpvm0KCbZjihE3ZVlCA
  //   - **uid**: bob@example.com
  validateToken() {
    return Vue.http.get('auth/validate_token').then((res) => {
      let user = res.body.data;
      return Promise.resolve(user);
    }, (res) => {
      console.log('SERVER SAYS INVALID TOKEN', res);
      return Promise.reject();
    })
  },


  login(credentials) {
    return Vue.http.post('auth/sign_in', credentials).then((res) => {
      let user = res.body.data;
      return Promise.resolve(user);
    }, (res) => {
      let errors = ['Login failed'];
      try {
        errors = res.body.errors;
      } catch(e) {}
      return Promise.reject(errors);
    })
  },

  logout() {
    return Vue.http.delete('auth/sign_out');
  },

  register(userData) {
    return Vue.http.post('auth', userData).then((res) => {
      let user = res.body.data;
      return Promise.resolve(user);
    }, (res) => {
      let errors = ['Failed to register'];
      try {
        errors = res.body.errors.full_messages;
      } catch(e) {}
      return Promise.reject(errors);
    });
  },

  update(userData) {
    return Vue.http.patch('auth', userData).then((res) => {
      let user = res.body.data;
      return Promise.resolve(user);
    }, (res) => {
      let errors = ['Failed to update settings'];
      try {
        errors = res.body.errors.full_messages;
      } catch (e) { }
      return Promise.reject(errors);
    });
  },

  forgotPassword(payload) {
    return Vue.http.post('auth/password', payload).then((res) => {
      let user = res.body.data;
      return Promise.resolve(user);
    }, (res) => {
      let errors = ['Password reset failed'];
      try {
        errors = res.body.errors;
      } catch (e) { }
      return Promise.reject(errors);
    })
  },

  resetPassword(payload) {
    let headers = {
      'Access-Token': payload.accessToken,
      'Client': payload.clientId,
      'uid': payload.uid,
    };

    return Vue.http.put('auth/password', payload.credentials, {headers}).then((res) => {
      let user = res.body.data;
      return Promise.resolve(user);
    }, (res) => {
      let errors = ['Password reset failed'];
      try {
        errors = res.body.errors;
      } catch (e) { }
      return Promise.reject(errors);
    })
  },
}



// WEBPACK FOOTER //
// ./src/services/auth.js